import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { Fragment } from "react";

function TableSkeleton({ columns = 5, rows = 5, pagination = true }) {
  let rowArr = Array(rows)?.fill(0);
  let colArr = Array(columns)?.fill(0);
  return (
    <Fragment>
      <TableContainer sx={{ border: "1px solid #e0e0e0", borderRadius: "5px" }}>
        <Table>
          <TableHead>
            <TableRow>
              {colArr?.map((_, index) => (
                <TableCell key={`headCell_${index}`} component="th" scope="row">
                  <Skeleton animation="wave" variant="text" height="30px" />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowArr?.map((_, index) => (
              <TableRow key={`bodyRow_${index}`}>
                <TableCell component="th" scope="row">
                  <Skeleton animation="wave" variant="text" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" variant="text" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" variant="text" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" variant="text" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" variant="text" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {pagination && (
        <Skeleton
          animation="wave"
          variant="rounded"
          height="4.5rem"
          sx={{ m: "0.5rem auto" }}
        />
      )}
    </Fragment>
  );
}

export default TableSkeleton;
